export default {
  main: {
    colors: {
      background: {
        default: "#c0d9bf",
        secondary: "#a1afa0",
        tertiary: "#ffffff",
      },
      foreground: {
        default: "#000000",
      },
      danger: {
        default: "#E15554",
        dark: "#801616",
        light: "#FF9A99",
        verylight: "#FFCCCC",
      },
      warning: {
        default: "#E1BC29",
        dark: "#997A00",
        light: "#FFDF61",
        verylight: "#FFF2BF",
      },
    },
    fonts: {
      h1: {
        size: "3.75rem",
        weight: "400",
      },
      s1: {
        size: "1.25rem",
        weight: "400",
      },
      s2: {
        size: "1rem",
        weight: "300",
      },
      button: {
        size: "0.875rem",
        weight: "300",
      },
    },
  },
};
